<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <paginated-table
          :title="$t('title.journal_publish_management')"
          icon="toc"
          :columns="columns"
          :data="journals"
          @updatePagination="updatePagination"
        >
        </paginated-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";

import { getJournalPublishManagementColumns } from "@/fields/journal/columns";

import { journalApi } from "@/api/api";

const hp_url = process.env.VUE_APP_SERVICE_HP_URL;

export default {
  components: {
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      tableIcon: "manage_search",
      isLoading: false,
      journals: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 5,
          total_pages: 1,
        },
        elements: [],
      },
      columns: getJournalPublishManagementColumns({
        edit: this.handleEdit,
        show: this.handleShow,
      }),
    };
  },
  methods: {
    /**
     * ****************************************************************************************
     * 버튼 액션
     * ****************************************************************************************/
    handleEdit(item) {
      if (item.is_published) {
        this.notifyVue({
          message: this.$t("alert.already_published_journal"),
          style: "warning",
        });
        return;
      }

      this.$router.push(`/journals/${item.idx}/contents/edit`);
    },
    handleShow(item) {
      if (!item.is_published) {
        this.notifyVue({
          message: this.$t("alert.not_yet_published_journal"),
          style: "warning",
        });
        return;
      }

      if (!hp_url) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        return;
      }

      const archivePathByType = {
        jnl: "/journal/archives",
        procs: "/conferences/archives",
        abst: "/conferences/archives",
      };

      const archivePath = archivePathByType[item?.journal_type?.code];
      if (!archivePath) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        return;
      }

      window.open(`${hp_url}${archivePath}`, "_blank");
    },
    /**
     * ****************************************************************************************
     * api 호출
     * ****************************************************************************************/
    async fetchJournals(size, page) {
      try {
        this.isLoading = true;
        const params = {
          size: size,
          page: page,
        };
        const response = await journalApi.showJournalForPublish(params);
        if (response.status === 200) {
          this.journals = response.data.response;
        } else {
          this.notifyVue({
            message: this.$t("alert.failed_request"),
            style: "danger",
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * ****************************************************************************************
     * 페이지네이션 업데이트
     * ****************************************************************************************/
    updatePagination(pagination) {
      this.journals.page_info.size = pagination.size;
      this.journals.page_info.page = pagination.page;

      this.fetchJournals(
        this.journals.page_info.size,
        this.journals.page_info.page
      );
    },
    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  mounted() {
    this.fetchJournals(
      this.journals.page_info.size,
      this.journals.page_info.page
    );
  },
};
</script>
<style scoped></style>
